import { logger } from "@/utils/logger";

// Global AbortController registry
let activeRequestControllers: AbortController[] = [];

/**
 * Register an AbortController for a new request
 */
export const registerRequestController = (controller: AbortController) => {
  activeRequestControllers.push(controller);
};

/**
 * Remove an AbortController from the registry after a request completes
 */
export const removeRequestController = (controller: AbortController) => {
  activeRequestControllers = activeRequestControllers.filter(c => c !== controller);
};

/**
 * Cancel all pending requests
 * Important: Call this before logging out to prevent auth errors
 */
export const cancelAllRequests = () => {
  logger.info(`Canceling ${activeRequestControllers.length} pending requests`);
  activeRequestControllers.forEach(controller => {
    try {
      controller.abort();
    } catch (error) {
      logger.error('Error aborting request:', error);
    }
  });
  activeRequestControllers = [];
};

/**
 * Create an AbortController with automatic registration
 */
export const createRegisteredAbortController = () => {
  const controller = new AbortController();
  registerRequestController(controller);
  return controller;
};

/**
 * Wrap a fetch call with an auto-registered AbortController
 */
export const createCancellableFetch = () => {
  const controller = createRegisteredAbortController();
  return {
    signal: controller.signal,
    controller,
  };
};
